import React from "react";
import "./Tabs.scss";

export const Tabs = ({ className, activeId, children }) => {
	const checkActiveId = (id) => {
		return activeId === id ? "tab-active" : "";
	};

	return (
		<div
			className={`custom-tabs flex direction-row align-items-center justify-content-center ${
				className ? className : ""
			}`}
		>
			{React.Children.map(children, (child) =>
				React.cloneElement(child, { className: checkActiveId(child.props.id) })
			)}
		</div>
	);
};
